"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    none: "0",
    thin: "1px",
    thick: "2px",
    heavy: "4px",
};
// Path: src/tokens/borders/width.ts
//# sourceMappingURL=width.js.map